<template>
  <v-col class="d-flex flex-column justify-center align-center ">
    <h1 :class="{
      'display-2': true,
      'mb-3': true,
      'font-weight-light': true,
      'white--text': light
    }"> Психолог </h1>
    <h1 :class="{
      'display-3': true,
      'mb-3': true,
      'text-center':true,
      'font-weight-light': true,
      'white--text': light}"
    >Мария Юдина</h1>
    <p :class="{'title': true, 'font-weight-light': true, 'white--text': light}">Психологическая помощь</p>
<!--    todo: заменить на router push через метод?-->
    <router-link
      to="/sign_up"
      :class="{
        'my-4': true,
        'v-btn': true,
        'v-btn--contained': true,
        'v-btn--rounded': true,
        'theme--light': true,
        'v-size--default' : true,
        'secondary': !light,
        'text-center' :true,
        }"
    >
      <span :class="{
        'v-btn__content' : true,
        'black--text': light,
        }">
        Записаться на консультацию
      </span>
    </router-link>

    <v-btn
      :dark="light"
      fab
      outlined
      @click="$vuetify.goTo('#about-me')"
    >
      <v-icon>mdi-chevron-double-down</v-icon>
    </v-btn>
  </v-col>

</template>

<script>
export default {
  name: "MainInfo",
  props: {
    light: {
      type: Boolean,
      default: false,
    }
  }
}
</script>

<style scoped>

</style>